import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Upload, Avatar, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import env from "./../../env";
import { updateAvatar } from "../../redux/userSlice";
import "./index.css";

function ProfilePictureComponent({ user_id, size }) {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);
  console.log("Current User in ProfilePictureComponent:", currentUser);
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const props = {
    name: "profile_photo_path",
    action: `${env.API_URL}/profile-picture/${user_id}`,
    method: "post",
    accept: ".jpg,.jpeg,.png,.gif",
    showUploadList: false,
    className: "avatar-uploader",
    headers: {
      authorization: `Bearer ${currentUser?.token}`,
    },
    onChange(info) {
      if (info.file.status === "uploading") {
        setLoading(true);
      } else if (info.file.status === "done") {
        setLoading(false);

        // ✅ use server response path for redux
        const uploadedPath = info.file.response?.profile_photo_path;
        if (uploadedPath) {
          dispatch(updateAvatar(uploadedPath));
        }

        // ✅ local preview
        const reader = new FileReader();
        reader.onload = (e) => setPreviewImage(e.target.result);
        if (info.file.originFileObj) {
          reader.readAsDataURL(info.file.originFileObj);
        }
      } else if (info.file.status === "error") {
        setLoading(false);
      }
    },
  };

  // ✅ Decide which image URL to show
  const avatarSrc = previewImage
    ? previewImage
    : currentUser?.profile_photo_path
    ? currentUser.profile_photo_path.startsWith("http")
      ? currentUser.profile_photo_path
      : `${env.STORAGE_URL}/uploads/${currentUser.profile_photo_path}`
    : undefined;

  return (
    <Spin spinning={loading}>
      <ImgCrop showGrid rotationSlider>
        <Upload {...props}>
          <Avatar size={size} src={avatarSrc} icon={<UserOutlined />} />
        </Upload>
      </ImgCrop>
    </Spin>
  );
}

export default ProfilePictureComponent;
